export default __webpack_public_path__ + "static/media/hot-5.c263ac62.png";